module.exports = __webpack_public_path__ + "img/markerBlue.9419fb87.png";